import React, { useState } from "react";
import { useUID } from "react-uid";

import { IconButton } from "@material-ui/core";

import DeleteSweepIcon from "@material-ui/icons/DeleteSweep";
import { red } from "@material-ui/core/colors";

export default function DeleteButton({ id, onDelete }) {
  const uid = useUID();
  const [active, setActive] = useState(false);

  const handleDelete = () => {
    active ? onDelete(id) : setActive(true);

    setTimeout(() => {
      setActive(false);
    }, 5000);
  };

  return (
    <IconButton id={`delete-btn-${uid}`} onClick={handleDelete}>
      <DeleteSweepIcon
        style={{
          fontSize: 32,
          ...(active && { color: red[500] }),
        }}
      />
    </IconButton>
  );
}
